/* ready */
$(function() {
  'use strict';

  $('.p-top-intvw__slide').slick({
    centerMode: true,
    centerPadding: '100px',
    slidesToShow: 3,
    autoplay: true,
    autoplaySpeed: 3000,
    initialSlide: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          centerPadding: '50px'
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          centerMode: false,
          centerPadding: '0'
        }
      }
    ]
  });
});